import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-itau-dashboard',
  templateUrl: './itau-dashboard.component.html',
  styleUrl: './itau-dashboard.component.scss'
})
export class ItauDashboardComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  tab: number;

  async ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['tab'] && !Number.isNaN(params['tab'])) {
        this.tab = Number(params['tab']);
      } else {
        this.tab = 0;
      }
    });
  }

  navigate(tab?: number) {
    if (tab !== undefined) this.tab = tab;
    this.router.navigate(['/financial/itau-dashboard'], {
      queryParams: { tab }
    });
  }
}
